import React from 'react';

import CoursePauseRequestedRequestsTable from './CoursePauseRequestedRequestsTable';
import CoursePauseRequestedRequestUpdateModal from './CoursePauseRequestedRequestUpdateModal';
import styles from './CoursePauseRequestedPage.module.scss';

function CoursePauseRequestedPage() {
  return (
    <div className={styles.root}>
      <CoursePauseRequestedRequestsTable />
      <CoursePauseRequestedRequestUpdateModal />
    </div>
  );
}

export default CoursePauseRequestedPage;
